<template>
  <el-dialog :visible.sync="show" :title="name" fullscreen class="fixed-header-footer-dialog">
    <el-form ref="formRef" size="small" :model="data" label-width="120px" label-position="right" :rules="rules">
      <el-row :gutter="20" style="display: flex; flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item prop="name" label="商铺">
            <el-input v-model="data.name" placeholder="请输入商铺"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="type !== '1'">
          <el-form-item prop="platform_id_name" label="场站名称">
            {{ data.platform_id_name }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="create_tenant_name" label="企业名称">
            <el-input v-model="data.create_tenant_name" placeholder="输入企业名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="create_tenant_id" label="企业">
            <el-select v-model="data.create_tenant_id" placeholder="选择企业" filterable style="width: 100%"
              :disabled="type === '1'">
              <el-option v-for="(item, index) in tenantList" :key="index" :value="item.id"
                :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="tags_list" label="标签">
            <el-select v-model="data.tags_list" placeholder="输入标签" multiple filterable allow-create default-first-option
              style="width: 100%;">
              <el-option v-for="item in []" :key="item" :value="item" :label="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="type === '0'">
          <el-form-item prop="digital_system" label="数字化系统">
            <el-switch v-model="data.digital_system" active-text="已开通" inactive-text="未开通" :active-value="true"
              :inactive-value="false" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="type === '0'">
          <el-form-item prop="claim" label="认领">
            <el-switch v-model="data.claim" active-text="已认领" inactive-text="未认领" :active-value="true"
              :inactive-value="false" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="address" label="地址">
            <shop-address :model-value="data.address" :model-data="data" @update-modelData="updateModelData" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="score" label="评分">
            <el-rate v-model="data.score" :colors="['#99A9BF', '#F7BA2A', '#7BC139']" score-template="{value}"
              style="margin-top: 5px;" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="coordinates" label="坐标">
            <el-input v-model="data.coordinates" placeholder="请输入坐标"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="contact_name" label="联系人">
            <el-input v-model="data.contact_name" placeholder="请输入联系人" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="phone" label="联系人手机号">
            <el-input v-model="data.phone" placeholder="请输入联系人手机号" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '1'">
          <el-form-item prop="main_product" label="主营">
            <el-input v-model="data.main_product" placeholder="请输入主营" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="type === '0'">
          <el-form-item prop="starting_station_id" label="起票站">
            <el-select v-model="data.starting_station_id" placeholder="请选择起票站" filterable clearable
              style="width: 100%;">
              <el-option v-for="item in startingStationList" :value="item.id" :label="item.name"
                :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="type === '0'">
          <el-form-item prop="shipping_capacity" label="发运能力">
            <el-input v-model="data.shipping_capacity" type="number" placeholder="请输入发运能力">
              <template #append>万吨/年</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '0'">
          <el-form-item prop="railWayList" label="铁路接轨线">
            <el-button type="primary" @click="handleToLines" style="margin-right: 10px;">选择</el-button>
            <el-tag v-for="item in railWayList" type="primary" style="margin: 0 10px 10px 0;" closable
              @close="handleClearLines(item)" :key="item.id">
              {{ item.name }}</el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <img-upload :data="data" :rules="rules" label="全景图" field="banner_image_url" :limit="1" />
        </el-col>
        <el-col :span="24">
          <img-upload :field="type === '2' ? 'infrastructure_image_url' : 'image_url'" :data="data" :rules="rules"
            :model="type === '0' ? 'sys_shop' : type === '1' ? 'sys_tenant_shop' : 'sys_park_shop'" label="图片"
            :limit="100" />
        </el-col>
        <el-col :span="24">
          <file-upload :data="data" :rules="rules" field="video_url" label="视频" :limit="100" :uploadType="['mp4']"
            :model="type === '0' ? 'sys_shop' : type === '1' ? 'sys_tenant_shop' : 'sys_park_shop'"
            uploadTypeText=".mp4"></file-upload>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="shipping_remark" label="备注">
            <el-input type="textarea" v-model="data.shipping_remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '0'">
          <el-form-item prop="shipping_introduced" label="铁路政策">
            <editor v-model="data.shipping_introduced" model="sys_shop" field="shipping_introduced"
              @input="handleEditorInput" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '1'">
          <el-form-item prop="business_introduced" label="主营产品介绍">
            <editor v-model="data.business_introduced" model="sys_tenant_shop" field="business_introduced"
              @input="handleEditorInput" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type !== '2'">
          <el-form-item prop="company_introduced" :label="type === '0' ? '公司简介' : '企业介绍'">
            <editor v-model="data.company_introduced" :model="type === '0' ? 'sys_shop' : 'sys_tenant_shop'"
              field="company_introduced" @input="handleEditorInput" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '2'">
          <el-form-item prop="infrastructure_introduced" label="介绍">
            <editor v-model="data.infrastructure_introduced" model="sys_park_shop" field="infrastructure_introduced"
              @input="handleEditorInput" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="type === '0'">
          <img-upload field="toll_image_url" :data="data" :rules="rules" model="sys_shop" label="收费标准图片" :limit="100" />
          <el-form-item prop="toll_introduced" label="收费标准介绍">
            <editor v-model="data.toll_introduced" model="sys_shop" field="toll_introduced"
              @input="handleEditorInput" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <railway-lines ref="railwayLinesRef" @fetchRailWay="fetchRailWayLines" />
    <template #footer>
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="handleSave" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import XEUtils from 'xe-utils'
import ShopAddress from '@/components/address/address.vue'
import ImgUpload from '@/imgUpload.vue'
import FileUpload from '@/fileUpload.vue'
import RailwayLines from './railwaylines.vue'
import Editor from '@/editor.vue'

export default {
  data() {
    return {
      data: {},
      show: false,
      rules: {
        create_tenant_id: [{ required: true, trigger: 'change', message: '选择企业' }],
      },
      name: '',
      type: '',
      tenantList: [],
      loading: false,
      startingStationList: [],
      railWayList: []
    }
  },
  components: { ShopAddress, ImgUpload, FileUpload, RailwayLines, Editor },
  methods: {
    display(event) {
      this.$set(this, 'data', JSON.parse(JSON.stringify(event.data || {})))
      this.$set(this, 'type', event.type)
      this.$set(this, 'name', this.type === '0' ? '更新场站商铺' : this.type === '1' ? '更新企业商铺' : '更新物流园区商铺')
      this.$set(this, 'show', true)
      this.$set(this, 'loading', false)
      this.$set(this.data, 'tags_list', this.data.tags ? this.data.tags.split(',') : [])
      this.handleTenantList()
      this.fetchHavePhone()
      if (this.type === '0') {
        this.$set(this.data, 'starting_station_id', this.data.starting_station_id.id !== -1 ? this.data.starting_station_id.id : '')
        this.fetchStartingStationList()
        this.fetchRailWayLines()
      }
    },
    handleEditorInput(event) {
      this.data[event.field] = event.data
    },
    fetchStartingStationList() {
      this.startingStationList = []
      const params = {
        conditions: [],
        pageNum: 1,
        pageSize: 6000,
        sorts: []
      }
      this.$axios.post('/paas/station_95306/list', params).then(res => {
        this.startingStationList = res.data.data.list
      })
    },
    fetchRailWayLines() {
      this.railWayList = []
      const params = {
        conditions: [{ field: 'shop_id', operator: '=', value1: this.data.id }],
        pageNum: 1,
        pageSize: 6000,
        sorts: []
      }
      this.$axios.post('/paas/sys_shop_railway_line/list', params).then(res => {
        this.railWayList = res.data.data.list
      })
    },
    fetchHavePhone() {
      const params = {
        params: {
          modelCode: this.type === '0' ? 'sys_shop' : this.type === '1' ? 'sys_tenant_shop' : 'sys_park_shop',
          fieldCode: 'phone',
          modelId: this.data.id
        }
      }
      if (this.data.have_phone) {
        this.$axios.get('/account/phone/query', params).then(res => {
          this.$set(this.data, 'phone', res.data.data.originPhone)
        })
      }
    },
    handleTenantList() {
      this.$axios.get('/account/tenant/all').then(res => {
        this.tenantList = res.data.data
      }).catch(() => {
        this.tenantList = []
      })
    },
    handleSave() {
      this.$refs.formRef.validate((vali) => {
        if (vali) {
          if ((!this.data.coordinates || this.data.coordinates === '0,0') && this.data.address) {
            this.$message.error({ showClose: true, message: '地址必须选择坐标!' })
          } else {
            this.$set(this, 'loading', true)
            const params = XEUtils.clone(this.data, true)
            params['tags'] = this.data.tags_list.toString()
            delete params['tags_list']
            for (let i = 0; i < this.tenantList.length; i++) {
              const item = this.tenantList[i]
              if (this.data.create_tenant_id === item.id && this.data.create_tenant_id !== 906) {
                params['create_tenant_name'] = item.name
              }
            }
            if (this.data.starting_station_id) {
              for (let i = 0; i < this.startingStationList.length; i++) {
                const item = this.startingStationList[i]
                if (this.data.starting_station_id === item.id) {
                  params['starting_station_id'] = { id: item.id, name: item.name }
                  params['starting_station_id_name'] = item.name
                  break
                }
              }
            } else {
              params['starting_station_id'] = { id: -1, name: '' }
              params['starting_station_id_name'] = ''
            }
            let url
            if (this.type === '0') {
              url = this.$axios.post('/paas/eventEmit/emit/sys_shop/sys_shop_update', params)
            } else if (this.type === '1') {
              url = this.$axios.post('/paas/eventEmit/emit/sys_tenant_shop/sys_tenant_shop_update', params)
            } else {
              url = this.$axios.post('/paas/eventEmit/emit/sys_park_shop/sys_park_shop_update', params)
            }
            url.then(() => {
              this.$message.success({ showClose: true, message: '更新成功' })
              this.$emit('init')
              this.$set(this, 'loading', false)
              this.$set(this, 'show', false)
            }).catch(() => {
              this.$set(this, 'loading', false)
            })
          }
        } else {
          return false
        }
      })
    },
    updateModelData(event) {
      this.$set(this.data, 'address', event.address)
      this.$set(this.data, 'coordinates', event.longitude + ',' + event.latitude)
      this.$set(this.data, 'province', event.province)
      this.$set(this.data, 'city', event.city)
      this.$set(this.data, 'district', event.district)
    },
    handleToLines() {
      this.$refs.railwayLinesRef.display({ railWayLines: this.railWayList, data: this.data })
    },
    handleClearLines(item) {
      const params = { id: item.id, modelCode: "sys_shop_railway_line", fieldCode: "del", value: true }
      this.$axios.post('/paas/eventEmit/updateSingleField', params).then(() => {
        this.$message.success({ showClose: true, message: '删除成功' })
        this.fetchRailWayLines()
      })
    }
  }
}
</script>

<style>
/* 固定 dialog 头部和底部，body 可滚动 */
.fixed-header-footer-dialog .el-dialog__body {
  max-height: calc(100vh - 170px) !important;
  /* 根据实际调整：header + footer + padding ≈ 240px */
  overflow-y: auto !important;
  padding: 20px !important;
}
</style>